<ol
  class="nav nav-pills tabs gap-1 flex-nowrap overflow-x-auto text-nowrap"
  [class.disabled]="isSelectedTabInvalid()"
  [class.enabled]="!isSelectedTabInvalid()">
  @for (tab of tabs(); track tab; let index = $index) {
    <a class="tab text-sm-center nav-link"
       [class.active]="tab.isSelected()"
       [class.invalid]="tab.isInvalid()"
       (click)="select(tab)">
      @if (tab.icon()) {
        <lucide-icon [img]="tab.icon()" class="me-1"></lucide-icon>
      }
      {{ tab.title() }}
    </a>
  }
</ol>

@if (isSelectedTabInvalid()) {
  <p class="text-primary">
    Complète les informations ci-dessous pour passer à l'étape suivante.
  </p>
}

<div class="tabs-content pt-4">
  <ng-content select="app-tab-item"></ng-content>
</div>
